//Generated File
export default class MenuTargetType{
	static readonly AllReports = `AllReports`;
	static readonly AutoDashBoards = `AutoDashBoards`;
	static readonly Dashboard = `Dashboard`;
	static readonly DashboardsGroup = `DashboardsGroup`;
	static readonly EntityList = `EntityList`;
	static readonly InternalLink = `InternalLink`;
	static readonly Link = `Link`;
	static readonly NewRecord = `NewRecord`;
	static readonly Record = `Record`;
	static readonly Report = `Report`;
	static readonly ReportsGroup = `ReportsGroup`;
	static readonly UserFavourites = `UserFavourites`;
}
